import http from './utils';
import { prefix } from './constants';

type TApiFunction<TPayload = any, TResponse = any> = (
  payload: TPayload,
) => Promise<TResponse>;

/**
 * Creative Trends 接口集合（接入线上数据）
 *
 * 接口文档：src/pages/marketing/specs/CreativeTrends/api/
 *  - tab_stats          → 三档 Tab 命中数
 *  - list               → 趋势列表（Card View / List View 共用）
 *  - detail             → Drawer 头部详情
 *  - related_creatives  → 该趋势关联的完整素材列表（Drawer 下半 + 详情页）
 */

/**
 * 获取 Creative Trends 三档 Tab（hot/rising/new）命中数
 * POST /api/v1/marketing/creative_trends/tab_stats
 * 返回: { hot, rising, new }
 */
export const getCreativeTrendsStats: TApiFunction = payload => {
  return http({
    url: `${prefix}/creative_trends/tab_stats`,
    method: 'post',
    ...payload,
  }) as Promise<any>;
};

/**
 * 获取 Creative Trends 列表（Card View + List View 共用）
 * POST /api/v1/marketing/creative_trends/list
 * 返回: { total, list, has_data_date? }
 */
export const getCreativeTrendsList: TApiFunction = payload => {
  return http({
    url: `${prefix}/creative_trends/list`,
    method: 'post',
    ...payload,
  }) as Promise<any>;
};

/**
 * 获取 Creative Trend 详情（Drawer 头部 + 详情页 TrendInfo 共用）
 * POST /api/v1/marketing/creative_trends/detail
 *
 * ⚠️ 主键：(game_id, topic) — 不再使用 trend_id
 */
export const getCreativeTrendDetail: TApiFunction = payload => {
  return http({
    url: `${prefix}/creative_trends/detail`,
    method: 'post',
    ...payload,
  }) as Promise<any>;
};

/**
 * 获取 Creative Trend 关联素材列表（Drawer RelatedCreatives + 详情页素材区域）
 * POST /api/v1/marketing/creative_trends/related_creatives
 *
 * 字段语义对齐 /materials/list（含 group_by/types/platforms/channels/countries/regions/...）
 * 返回: { total, list, max }
 */
export const getCreativeTrendRelatedCreatives: TApiFunction = payload => {
  return http({
    url: `${prefix}/creative_trends/related_creatives`,
    method: 'post',
    ...payload,
  }) as Promise<any>;
};
